module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "additional"
  }, [_c('h3', [_vm._v("Additional")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "http://codeschool.com/users/933700/",
      "target": "_blank"
    }
  }, [_vm._v("CodeSchool Report")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Brushing up on fundamentals when needed")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title",
    attrs: {
      "href": "https://github.com/cygri/pubby/pull/22/",
      "target": "_blank"
    }
  }, [_vm._v("Open Source Pubby Project")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("UI/UX updates to the Pubby Project.")])]), _vm._v(" "), _c('div', {
    staticClass: "project-item"
  }, [_c('a', {
    staticClass: "project-title"
  }, [_vm._v("Certified Scuba Diver")]), _vm._v(" "), _c('p', {
    staticClass: "project-desc"
  }, [_vm._v("My love for water")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da187e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Additional.vue
// module id = 52
// module chunks = 0